import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../graphql.module';
import { Uuid } from '../../../../../graphql';
import { GetJobsCountByCustomerId } from '../queries/GetJobsCountByCustomerId.generated';
import { GetLeadsCountByCustomerId } from '../queries/GetLeadsCountByCustomerId.generated';
import { GetEstimatesCountByCustomerId } from '../queries/GetEstimatesCountByCustomerId.generated';
import { DeleteCustomer } from '../mutations/DeleteCustomer.generated';
import { RestoreCustomer } from '../mutations/RestoreCustomer.generated';

@Injectable({
    providedIn: 'root',
})
export class ClientsApiService {
    #apollo = inject(Apollo);

    private get gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getJobsCount(clientId: Uuid) {
        return this.gql.query({
            query: GetJobsCountByCustomerId,
            variables: {
                customerId: clientId,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    getLeadsCount(clientId: Uuid) {
        return this.gql.query({
            query: GetLeadsCountByCustomerId,
            variables: {
                customerId: clientId,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    getEstimatesCount(clientId: Uuid) {
        return this.gql.query({
            query: GetEstimatesCountByCustomerId,
            variables: {
                customerId: clientId,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    deleteClient(id: Uuid) {
        return this.gql.mutate({
            mutation: DeleteCustomer,
            variables: {
                input: {
                    customerId: id,
                },
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    restoreClient(id: Uuid) {
        return this.gql.mutate({
            mutation: RestoreCustomer,
            variables: {
                input: {
                    customerId: id,
                },
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
